
export const endpoints = {

  authentication: {
    signIn: '/auth/authenticate',
    signOut: '/auth/sign-out',
    getUser: '/auth/user',
    getContext: '/auth/context',
    refreshToken: '/auth/refresh',
  },

  users: {
    resetPassword: '/users/reset-password',
    signUp: '/users/register',
    newPassword: '/users/new-password',
    changePassword: '/users/password',
    update: '/users/update/',
    getUser: '/users/',
    getUsers: '/users',
    status: '/users/status',
    rotateStatus: '/users/rotate-status',
    uploadFile: '/users/{id}/photo'
  },


  teachers: {
    create: '/teachers',
    getTeachers: '/teachers',
    getTeacherSubjects: '/teachers/details/',
    getTeacher: '/teachers/',
    update: '/teachers',
    status: '/teachers/status',
    uploadFile: '/teachers/files/photo',
  },


  terms: {
    create: '/terms',
    getTerms: '/terms',
    getTerm: '/terms/',
    update: '/terms',
    status: '/terms/status',
    rotateStatus: '/terms/rotate-status',
  },


  class: {
    create: '/classes',
    getClasses: '/classes',
    getClass:'/classes/',
    getClassDetails: '/classes/subjects/',
    update: '/classes',
    status: '/classes/status',
    assign: '/classes/assign/',
    unassign: '/classes/unassign/',   
    GraduateStatus: '/classes/graduate-status/'
  },

  subject: {
    create: '/subjects',
    All: '/subjects',
    get:'/subjects/',
    update: '/subjects',
    delete: '/subjects/status',
    details: '/subjects/details/',
    assign: '/subjects/assign',
    unassign: '/subjects/unassign',   
  },

  students: {
    create: '/students',
    All: '/students',
    get:'/students/',
    update: '/students/update/',
    delete: '/students/status',
    class: '/students/class/',
    parents: '/students/parents/',
    class_students: '/students/student_in_class/',
    generateIndexNo: '/students/generate-numbers/',
    uploadStudentPhoto: '/students/{id}/photo'
  },

  parents: {
    create: '/parents',
    All: '/parents',
    get:'/parents/',
    update: '/parents',
    delete: '/parents/status',
    status: '/parents/status',
    students: '/parents/students/',
    assign : '/parents/assign/',
    unassign : '/parents/unassign/',
    getAssignments : '/parents/assignments/',
    uploadFile: '/parents/upload'
  },

  
  examinationType: {
    create: '/examination-types',
    getExams: '/examination-types',
    getExaminationType: '/examination-types/',
    update: '/examination-types',
    delete: '/examination-types/status',
    getClassExams: '/examination-types/exams',
    getAll: '/examination-types/all',
    publish : '/examination-types/publish'
  },

  results: {
    initializeResults: '/results/generate-results',
    getResults: '/results',
    getResult: '/results/',
    update: '/results',
    status: '/results/status',
    getExamByClassId: '/results/examination-types',
    getTermsByClassId: '/results/list_class_terms',
    StudentResults : '/results/class-exam-student',
    classResults : '/results/class-and-exam',
    fetch_subject_results : '/results/clazz',
    generateSubjectResult: '/results/generate-results',
    sendSms : '/results/sms/notify/',
    getResultsByTermAndClass: '/results/term-class-results',
    getResultsByTermClassAndStudent: '/results/student-term-class-results',
    deleteClassSubjectResults: '/results/delete-class-subject-results',
  },

  sessions: {
    getUserSessions: '/sessions/user',
  },

  studentEvaluations: {
    create: '/student-evaluations',
    createByTermStudent: '/student-evaluations/by-term-student',
    All: '/student-evaluations',
    get: '/student-evaluations/',
    delete: '/student-evaluations/',
    getByTermStudent: '/student-evaluations/by-term-student',
    getByStudent: '/student-evaluations/by-student',
    getByTerm: '/student-evaluations/by-term',
    update: '/student-evaluations',
    updateByTermStudent: '/student-evaluations/by-term-student',
    updatePartialByTermStudent: '/student-evaluations/by-term-student',
    exists: '/student-evaluations/exists',
    status: '/student-evaluations/status',
    notifyParents: '/student-evaluations/notify-parents',
    notifyParentsByEvaluation: '/student-evaluations/notify-parents-by-evaluation',
  },

  accountants: {
    create: '/accountants',
    createByTermStudent: '/accountants/by-term-student',
    All: '/accountants',
    get: '/accountants/',
    delete: '/accountants/',
    getByTermStudent: '/accountants/by-term-student',
    getByStudent: '/accountants/by-student',
    getByTerm: '/accountants/by-term',
    getByTermClass: '/accountants/by-term-class',
    getTermsByClass: '/accountants/terms-by-class',
    getTermsByStudent: '/accountants/terms-by-student',
    update: '/accountants',
    updateByTermStudent: '/accountants/by-term-student',
    updatePartialByTermStudent: '/accountants/by-term-student',
    exists: '/accountants/exists',
    status: '/accountants/status',
    sendSmsAboutAccountsData: '/accountants/send-sms-about-accounts-data',
  },

  rectorComments: {
    create: '/rector-comments',
    createByTermStudent: '/rector-comments/by-term-student',
    All: '/rector-comments',
    get: '/rector-comments/',
    delete: '/rector-comments/',
    getByTermStudent: '/rector-comments/by-term-student',
    getByStudent: '/rector-comments/by-student',
    getByTerm: '/rector-comments/by-term',
    update: '/rector-comments',
    updateByTermStudent: '/rector-comments/by-term-student',
    updatePartialByTermStudent: '/rector-comments/by-term-student',
    exists: '/rector-comments/exists',
    status: '/rector-comments/status',
  },

  sessionTimeRanges: {
    create: '/clazz-timetables',
    getAll: '/clazz-timetables',
    get: '/clazz-timetables/',
    update: '/clazz-timetables',
    status: '/clazz-timetables/status',
    getAllActive: '/clazz-timetables/all/active',
    link: '/clazz-timetables/link',
    unlink: '/clazz-timetables/unlink',
    getSubjectsTeachersByClass: '/clazz-timetables/class',
    getTimetableByTeacher: '/clazz-timetables/teacher',
  },

  dutiesWeeks: {
    create: '/duties-weeks',
    getDutiesWeeks: '/duties-weeks',
    getDutiesWeek: '/duties-weeks/',
    getAll: '/duties-weeks/all',
    getByTerm: '/duties-weeks/term/',
    getByTermWithTeachers: '/duties-weeks/term/',
    update: '/duties-weeks',
    status: '/duties-weeks/status',
    assignTeacher: '/duties-weeks/assign-teacher',
    unassignTeacher: '/duties-weeks/unassign-teacher',
    getTeachers: '/duties-weeks/',
  },

  dashboard: {
    getStats: '/dashboard/stats',
  },

  announcements: {
    create: '/announcements',
    getAll: '/announcements',
    get: '/announcements/',
    update: '/announcements',
    delete: '/announcements/',
    getByClass: '/announcements/by-class/',
    status: '/announcements/status',
    sendSms: '/announcements/send-sms/',
    getByParent: '/announcements/by-parent/',
    getAllClasses: '/announcements/all-classes',
  },
};
